export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--3-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ArchiveProduct.vue?vue&type=template&id=d58399fe"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ArchiveProduct.vue?vue&type=template&id=d58399fe
// module id = 82
// module chunks = 0